import * as React from 'react'

import {ITablesDispatcher} from '../../interfaces/dispatchers'
import {ITableProps} from '../../interfaces/models'

interface Props extends ITableProps {
  tools: Array<(props: ITableProps, key: any) => JSX.Element>
  tableDispatcher?: ITablesDispatcher
}

interface State {
  page: number | undefined
}

class Pagination extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)

    this.getSafePage = this.getSafePage.bind(this)
    this.changePage = this.changePage.bind(this)
    this.applyPage = this.applyPage.bind(this)
    this.setStatePage = this.setStatePage.bind(this)

    this.state = {
      page: props.page
    }
  }

  componentDidUpdate(prevProps: Props) {
    if (prevProps.page !== this.props.page) {
      this.setState({page: this.props.page})
    }
  }

  private getSafePage(page: number) {
    const pages = this.props.pages || 0
    if (Number.isNaN(page)) {
      page = pages
    }
    return Math.min(Math.max(page, 0), pages - 1)
  }

  private setStatePage(page: number): void {
    this.setState({page})
    if (this.props.tableDispatcher) {
      this.props.tableDispatcher.setTableInfoExpanded(this.props.id, {})
    }
    if (this.props.page !== page) {
      this.props.onPageChange!(page)
    }
  }

  private changePage(page: number) {
    page = this.getSafePage(page)
    this.setState({page})
    if (this.props.tableDispatcher) {
      this.props.tableDispatcher.setTableInfoExpanded(this.props.id, {})
    }
    if (this.props.page !== page) {
      this.props.onPageChange!(page)
    }
  }

  private applyPage(e?: any) {
    if (e) {
      e.preventDefault()
    }
    const page = this.state.page
    this.changePage(!page && page != 0 ? this.props.page || 0 : page || 0)
  }

  private getNavigation() {
    if (!this.props.pages || this.props.pages < 2) {
      return null
    }
    return (
      <div style={{minWidth: '160px', width: '160px', display: 'flex'}}>
        <button
          type="button"
          onClick={() => {
            if (!this.props.canPrevious!) return
            this.changePage(this.props.page! - 1)
          }}
          disabled={!this.props.canPrevious!}
        >
          {this.props.previousText}
        </button>
        <div style={{minWidth: '100px', display: 'flex'}}>
          <input
            style={{width: '50%'}}
            type={this.props.page || this.props.page == 0 ? 'number' : 'text'}
            onChange={e => {
              const val = parseFloat(e.target.value)
              const page = val - 1
              if (val.toString() === '') {
                return this.setStatePage(val)
              }
              this.setStatePage(this.getSafePage(page))
            }}
            value={this.props.page || this.props.page == 0 ? this.props.page + 1 : ''}
            onBlur={this.applyPage}
            onKeyPress={e => {
              if (e.which === 13 || e.keyCode === 13) {
                this.applyPage()
              }
            }}
          />
          <span style={{width: '20%', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
            {this.props.ofText}
          </span>
          <span style={{width: '30%', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
            {this.props.pages || 1}
          </span>
        </div>
        <button
          type="button"
          onClick={() => {
            if (!this.props.canNext!) return
            this.changePage(this.props.page! + 1)
          }}
          disabled={!this.props.canNext!}
        >
          {this.props.nextText}
        </button>
      </div>
    )
  }

  getMoreTools() {
    const tools: Array<JSX.Element> = []

    this.props.tools.forEach((t, i) => {
      tools.push(<React.Fragment key={i}>{t(this.props, i)}</React.Fragment>)
    })

    return tools
  }

  getCountString() {
    let startIndex = 0
    let count = (this.props as ITableProps).recordsCount
    if (count === undefined) {
      count = this.props.data ? this.props.data!.length : 0
    }

    let pageSize = 0
    if (this.props.pageSize != undefined && this.props.page != undefined && this.props.data != undefined) {
      pageSize = this.props.pageSize
      startIndex = this.props.pageSize * this.props.page
    }
    let countString = ''
    if (count) {
      if (this.props.pages == 1) {
        countString = `Общо ${count} броя`
      } else {
        countString = `${startIndex + 1}-${startIndex + pageSize} от ${count}`
      }
    }
    return countString
  }

  render() {
    const countString = this.getCountString()
    const stringsStyle: React.CSSProperties = {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      padding: '6px'
    }
    const selectedIds = Object.keys((this.props as ITableProps).selectedIds || {}).length

    return this.props.pages && this.props.page != undefined ? (
      <div style={{display: 'flex', textAlign: 'center', justifyContent: 'space-between'}}>
        {this.getNavigation()}
        {(this.props as ITableProps).selectedIds ? <div style={stringsStyle}>{`${selectedIds} избрани`}</div> : null}
        {countString ? <div style={stringsStyle}>{countString}</div> : null}
        {this.getMoreTools()}
      </div>
    ) : null
  }

  static openedTools = {}
}

export default Pagination
